import { configureStore } from '@reduxjs/toolkit'
import { AuthSliceType, authSlice } from './auth/auth.slice'

export type StateType = {
    [authSlice.name]: AuthSliceType
}

export const store = configureStore<StateType>({
    reducer: {
        [authSlice.name]: authSlice.reducer,
    },
})
